<div class="cd-page">
  <!-- SIDEBAR -->
  <app-district-nav></app-district-nav>

  <!-- MAIN -->
  <main class="cd-main" aria-label="District Admin Help Desk">
    <div class="cd-header">
      <h1 class="cd-title">Help Desk</h1>
    </div>

    <div class="cd-stats" role="list" aria-label="Dashboard statistics">
      <div class="cd-stat" role="listitem" [attr.aria-label]="openCount() + ' open'">
        <div class="cd-stat-num">{{ openCount() }}</div>
        <div class="cd-stat-label">Total Open</div>
      </div>

      <div class="cd-stat" role="listitem" [attr.aria-label]="inProgressCount() + ' in progress'">
        <div class="cd-stat-num">{{ inProgressCount() }}</div>
        <div class="cd-stat-label">Total In Progress</div>
      </div>

      <div class="cd-stat" role="listitem" [attr.aria-label]="resolvedCount() + ' resolved'">
        <div class="cd-stat-num">{{ resolvedCount() }}</div>
        <div class="cd-stat-label">Total Resolved</div>
      </div>
    </div>

    <!-- District Reports -->
    <section class="reports-section">
      <div class="reports-header">
        <h2>District Reports</h2>

        <div class="reports-controls">
          <mat-chip-listbox
            [ngModel]="filter()"
            (ngModelChange)="filter.set($event)"
            hideSingleSelectionIndicator
            aria-label="Filter reports by status"
          >
            <mat-chip-option value="All">All</mat-chip-option>
            <mat-chip-option value="Open">Open</mat-chip-option>
            <mat-chip-option value="Resolved">Resolved</mat-chip-option>
          </mat-chip-listbox>

          <mat-form-field appearance="outline" class="cd-search" subscriptSizing="dynamic">
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              [ngModel]="query()"
              (ngModelChange)="query.set($event)"
              placeholder="Search reports"
              aria-label="Search reports"
              data-testid="issue-reports-search"
            />
          </mat-form-field>
        </div>
      </div>

      @if (filteredReports().length === 0) {
        <div class="cd-empty">
          <mat-icon>inbox</mat-icon>
          <p>No reports match. Try a different filter or search term.</p>
        </div>
      } @else {
        <div class="report-list">
          @for (r of filteredReports(); track r.id) {
            <button
              class="report-row"
              [ngClass]="'report-row--' + statusClass(r.status)"
              [attr.aria-label]="'Open report ' + ': ' + r.title"
              (click)="openReportDialog(r)"
              data-testid="issue-reports-open-report"
            >
              <div class="report-row-main">
                <div class="report-row-top">
                  <mat-chip
                    class="cd-chip"
                    [ngClass]="'cd-chip--' + categoryClass(r.category)"
                    disableRipple
                  >
                    <mat-icon matChipAvatar>{{ categoryIcon(r.category) }}</mat-icon>
                    {{ r.category }}
                  </mat-chip>

                  <span class="cd-priority" [ngClass]="'cd-priority--' + r.priority.toLowerCase()">
                    <span class="cd-priority-dot" aria-hidden="true"></span>{{ r.priority }}
                  </span>
                </div>

                <div class="report-row-title">{{ r.title }}</div>

                <div class="report-row-meta">
                  {{ r.school!.name }} &middot; opened
                  {{ r.submittedDate | date: 'MMM d, y' }}
                  @if (!r.assignedTo) {
                    &middot; Unassigned
                  } @else {
                    &middot; {{ r.assigneeName || 'User #' + r.assignedTo }}
                  }
                  @if (r.responses.length > 0) {
                    &middot; {{ r.responses.length }} response{{
                      r.responses.length > 1 ? 's' : ''
                    }}
                  }
                </div>
              </div>

              <div class="report-row-status">
                <app-status-stepper [status]="r.status" [compact]="true"></app-status-stepper>
              </div>

              <mat-icon class="report-row-chevron" aria-hidden="true">chevron_right</mat-icon>
            </button>
          }
        </div>
      }
    </section>
  </main>
</div>
